import styled from "styled-components";
import { Form } from "react-bootstrap";

export const StyledLabel = styled.label`
	font-weight: 500;
	margin-bottom: 8px;
	color: #333;
`;

export const StyledFormControl = styled(Form.Control).attrs((props) => ({
  autoComplete: props.autoComplete || "on"
}))`	border-radius: 4px;
	border: 1px solid #ddd;
	padding: 12px;
	font-size: 14px;
	autoComplete: props => props.autoComplete || "on";

	&:focus {
		border-color: #9036f7;
		box-shadow: 0 0 0 0.2rem rgba(144, 54, 247, 0.25);
	}
`;

export const StyledCheckLabel = styled.label`
	margin-top: 10px;
	display: flex;
	align-items: center;

	input[type="checkbox"] {
		margin-right: 8px;
		border-radius: 4px;

		&:checked {
			background-color: #9036f7;
			border-color: #9036f7;
		}

		&:focus {
			border-color: #9036f7;
			box-shadow: 0 0 0 0.2rem rgba(144, 54, 247, 0.25);
		}
	}
`;
